<div  fxLayout="column" class="page-container">
  <div fxLayout="column" class="instruction-container" fxLayoutAlign="center center">
    <div  fxLayoutAlign="center center" fxLayout="column" class="restricted">
      <h1>Sorry!</h1>
      <p>Because you have already played the Quiz before you are not able to play it again for a while!<br><br>Please try again next time!</p>
    </div>
    <div class="button-container">
      <eon-ui-button fullWidth text="Back to Start" (click)="navigateToStart()" scheme=white></eon-ui-button>
    </div>
  </div>

